import { Routes, Route, Navigate } from "react-router-dom";
import Register from "./Pages/authentication/Register";
import Login from "./Pages/authentication/Login";
import ForgotPassword from "./Pages/authentication/ForgotPassword";
import VerifyOtp from "./Pages/authentication/VerifyOtp";
import ResetPassword from "./Pages/authentication/ResetPassword";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ProfilePage from "./Pages/User/ProfilePage";
import EditProfileModal from "./Pages/User/EditProfileModal";
import AppointmentForm from "./Pages/Appointment/AppointmentForm";
import AppointmentList from "./Pages/Appointment/AppointmentList";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import RoleProtectedRoute from "./components/auth/RoleProtectedRoute";
import RoleBasedRedirect from "./components/auth/RoleBasedRedirect";
import ClinicList from "./Pages/Clinic/ClinicList";
import ClinicForm from "./Pages/Clinic/ClinicForm";
import SlotsList from "./Pages/Slots/SlotsList";
import SlotsForm from "./Pages/Slots/SlotsForm";
import SlotsBulkCreate from "./Pages/Slots/SlotsBulkCreate";
import PatientList from "./Pages/Patient/PatientList";
import PatientCreate from "./Pages/Patient/PatientCreate";
import RxTemplateList from "./Pages/RxTemplates/RxTemplateList";
import RxTemplateCreate from "./Pages/RxTemplates/RxTemplateCreate";
import RxTemplateEdit from "./Pages/RxTemplates/RxTemplateEdit";
import NotFound from "./Pages/NotFound"; // Import the NotFound component
import AllergyList from "./Pages/Allergy/AllergyList";
import TreatmentForm from "./Pages/Treatment/TreatmentForm";
import TreatmentList from "./Pages/Treatment/TreatmentList";
import MedicalConditionList from "./Pages/MedicalCondition/MedicalConditionList";
import TreatmentPlanList from "./Pages/TreatmentPlan/TreatmentPlanList";
import TreatmentPlanForm from "./Pages/TreatmentPlan/TreatmentPlanForm";
import EducationalResourceList from "./Pages/EducationalResources/EducationalResourceList";
import EducationalResourceForm from "./Pages/EducationalResources/EducationalResourceForm";
import PaymentForm from "./Pages/Payment/PaymentForm";
import PaymentPlanDetail from "./Pages/Payment/PaymentPlanDetail";
import PaymentList from "./Pages/Payment/PaymentList";
import TreatmentRecordList from "./Pages/TreatmentRecord/TreatmentRecordList";
import TreatmentRecordForm from "./Pages/TreatmentRecord/TreatmentRecordForm";
import PatientTimelineList from "./Pages/PatientTimeline/PatientTimelineList";
import DocumentsList from "./Pages/Documents/DocumentsList";
import DocumentsForm from "./Pages/Documents/DocumentsForm";
import Userlist from "./Pages/Admin/Userlist";

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<RoleBasedRedirect />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Role-based Protected Routes */}
      <Route path="/admin" element={
        <RoleProtectedRoute allowedRoles={["ADMIN"]}>
          <Userlist />
        </RoleProtectedRoute>
      } />
      <Route
        path="/dashboard"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <Dashboard />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-profile"
        element={
          <ProtectedRoute>
            <EditProfileModal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/appointments"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <AppointmentList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/appointments/create"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <AppointmentForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/appointments/create/:id"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <AppointmentForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/patients"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PatientList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/patients/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PatientCreate />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/clinics"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <ClinicList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/clinics/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <ClinicForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/slots"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <SlotsList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/slots/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <SlotsForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/slots/bulk"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <SlotsBulkCreate />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/rxtemplates"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <RxTemplateList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/rxtemplates/create"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <RxTemplateCreate />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/rxtemplates/edit/:id"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <RxTemplateEdit />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/educational-resources"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <EducationalResourceList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/educational-resources/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <EducationalResourceForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/allergy"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <AllergyList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/treatments"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <TreatmentList />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/treatment/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <TreatmentForm />
          </RoleProtectedRoute>
        }
      />

      {/* Treatment Record Routes */}
      <Route
        path="/treatment-records"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <TreatmentRecordList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/treatment-record/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <TreatmentRecordForm />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/medical"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <MedicalConditionList />
          </RoleProtectedRoute>
        }
      />
       {/* Treatment Plan Routes */}
      <Route path="/treatment-plan" element={<RoleProtectedRoute allowedRoles={["DOCTOR"]}><TreatmentPlanList /></RoleProtectedRoute>} />
      {/* ADDED THIS ROUTE for creating */}
      <Route path="/treatment-plan/create" element={<RoleProtectedRoute allowedRoles={["DOCTOR"]}><TreatmentPlanForm /></RoleProtectedRoute>} />
      {/* ADDED THIS ROUTE for editing */}
      <Route path="/treatment-plan/create/:id" element={<RoleProtectedRoute allowedRoles={["DOCTOR"]}><TreatmentPlanForm /></RoleProtectedRoute>} />

      {/* Payment Routes */}
      <Route
        path="/payments"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PaymentList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/payment/create/:patientId?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PaymentForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/payment/edit/:id/:patientId?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PaymentForm />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/payment/plan/:planId"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PaymentPlanDetail />
          </RoleProtectedRoute>
        }
      />

      {/* Patient Timeline */}
      <Route
        path="/patient-timeline"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <PatientTimelineList />
          </RoleProtectedRoute>
        }
      />

      {/* Documents */}
      <Route
        path="/documents"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <DocumentsList />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/documents/create/:id?"
        element={
          <RoleProtectedRoute allowedRoles={["DOCTOR"]}>
            <DocumentsForm />
          </RoleProtectedRoute>
        }
      />

      {/* Catch-all route for 404 Not Found */}

      {/* Catch-all route for 404 Not Found */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
